import "./style.css";

// Each entry pairs an opaque light tint with a deep foreground from the same
// hue, so the initials clear WCAG AA contrast over any surface the avatar sits
// on (white cards, tinted rows, the app bar).
const COLORS = [
  { backgroundColor: "#FFE4E6", borderColor: "#FECDD3", color: "#9F1239" },
  { backgroundColor: "#E0E9FB", borderColor: "#C3D4F5", color: "#002B7F" },
  { backgroundColor: "#FFEDD5", borderColor: "#FED7AA", color: "#9A3412" },
  { backgroundColor: "#E0E7FF", borderColor: "#C7D2FE", color: "#3730A3" },
];

const UIAvatar = ({ text, type, height, width, size, className, bordered = true }: any) => {
  const output =
    (type === "username" || type === "name") && text
      ? String(text)
          .split(" ")
          .map((item: string) => item[0])
          .filter((x: string) => x && x !== ".")
          .join("")
          .substring(0, 3)
          .toUpperCase()
      : "";

  // Derived from the text, not Math.random(): the colour used to change on
  // every re-render, so a person's avatar flickered between colours.
  const hash = String(text || "")
    .split("")
    .reduce((acc: number, char: string) => acc + char.charCodeAt(0), 0);
  const colorObj = COLORS[hash % COLORS.length];

  return (
    <div
      className={className ? `avatar ${className}` : "avatar"}
      style={{
        ...colorObj,
        // Longhands, not the `border` shorthand: the shorthand would reset
        // border-color to currentColor and discard the palette's borderColor.
        ...(bordered ? { borderWidth: "1px", borderStyle: "solid" } : {}),
        height: height || "48px",
        width: width || "48px",
      }}
    >
      <div className="content" style={{ fontSize: size || "14px" }}>
        {output}
      </div>
    </div>
  );
};

export { UIAvatar };
